import React from 'react';
import PropTypes from 'prop-types';

const GetDirections = ({ fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <g fill="none" fillRule="evenodd">
      <g fill={fill}>
        <g>
          <path
            d="M9.542 1.152l8.567 8.568-8.567 8.568L.974 9.72l8.568-8.568zm0-.954c-.149 0-.297.057-.41.17L.188 9.31c-.227.227-.227.594 0 .821l8.942 8.942c.114.113.262.17.41.17.15 0 .298-.057.41-.17l8.942-8.942c.227-.227.227-.594 0-.821L9.952.368c-.113-.114-.262-.17-.41-.17z"
            transform="translate(-1211 -957) translate(1211 957)"
          />
          <path
            d="M8.523 13.436h-2.55l-.02-4.652c-.003-.895.722-1.624 1.616-1.627l2.918-.01-.178-.982c-.062-.345.08-.68.37-.875.285-.19.663-.194.952-.008l.071.055 3.348 3.107-3.419 3.162c-.288.186-.667.182-.952-.008-.291-.195-.433-.53-.371-.874l.178-.983-1.942-.008-.02 3.703zM6.99 12.414h.517l.02-3.707 4.183.016-.311 1.714 2.148-1.993-2.148-1.993.311 1.715-4.137.014c-.33 0-.598.27-.597.602l.014 3.632z"
            transform="translate(-1211 -957) translate(1211 957)"
          />
        </g>
      </g>
    </g>
  </svg>
);

GetDirections.propTypes = {
  fill: PropTypes.string,
};

GetDirections.defaultProps = {
  fill: '#4a4a4a',
};

export default GetDirections;
